import { themeQuartz } from 'ag-grid-community';

export const shsThemeDark = themeQuartz.withParams({
    accentColor: 'rgb(var(--ui-3))',
    backgroundColor: 'var(--base-2)',
    borderColor: 'rgba(var(--ui-1), var(--opacity-75))',
    browserColorScheme: 'light',
    foregroundColor: 'var(--color-text-strong)',
    inputBackgroundColor: 'rgba(var(--ui-1), var(--opacity-50))'
});
